import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { useAppNavigation } from 'src/routes';

export const RouteErrorElement = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const { navigateTo } = useAppNavigation();
  const { t } = useTranslation();

  let errorMessage = t('general.somethingWentWrong') || 'Something went wrong';
  let errorTitle = '500';
  let statusCode: number | undefined;

  if (isRouteErrorResponse(error)) {
    statusCode = error.status;
    errorTitle = `${error.status}`;
    errorMessage = error.statusText || error.data?.message || errorMessage;
  } else if (error instanceof Error) {
    errorMessage = error.message || errorMessage;
  }

  const handleGoHome = () => {
    navigateTo.landing();
  };

  const handleReload = () => {
    navigate(0); // Reload the page
  };

  return (
    <div
      style={{ padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}
    >
      <Result
        status={statusCode === 404 ? '404' : statusCode === 403 ? '403' : '500'}
        title={errorTitle}
        subTitle={errorMessage}
        extra={[
          <Button type="primary" key="home" onClick={handleGoHome}>
            {t('general.home') || 'Go Home'}
          </Button>,
          <Button key="reload" onClick={handleReload}>
            {t('general.reload') || 'Reload Page'}
          </Button>,
        ]}
      />
    </div>
  );
};
